<template>
  <div>
    <div class="row">
      <h2 class="mx-auto"><strong>Build your holiday</strong></h2>
    </div>
    <div class="row">
      <div class="col">
        <app-dbd-day
          v-for="(day, index) in days"
          :key="day.number"
          :day="day"
          :prevDay="index > 0 ? days[index - 1] : null"
          :nextDay="index < days.length ? days[index + 1] : null"
        >
        </app-dbd-day>
      </div>
    </div>
    <div v-if="showExcrMessage" class="row">
      <div class="alert alert-info">
        We notice that you have not chosen any excursions for your trip. You can
        add an exursion by clicking
        <button class="btn btn-sm btn-info">Add Daytime Activity</button> on the
        day in question. If you don't intend to take any excursions then no
        bother, just click
        <button class="btn btn-sm btn-success" @click="nextStep">Next</button>
        to continue.
      </div>
    </div>
    <div v-if="showHotelMessage" class="row justify-content-around">
      <div class="alert alert-danger">
        Please select one or more Hotels for your stay by clicking
        <button
          @click="showProductDialog(1, 'Hotel')"
          class="btn btn-sm btn-success"
        >
          Add Hotel
        </button>
      </div>
    </div>
    <div class="row my-4 justify-content-end">
      <button class="btn btn-info mx-1" @click="prevStep">Previous</button>
      <button class="btn btn-success mx-1" @click="nextStep">Next</button>
    </div>
    <app-product-dialog
      :productType="dialogProductType"
      :products="products"
    ></app-product-dialog>
  </div>
</template>

<script>
import { eventBus } from '../../main.js'
import { mapState, mapGetters, mapActions } from 'vuex'
import appDbdDay from '../day-by-day/Day.vue'
import appProductDialog from '../day-by-day/product-dialog/Dialog.vue'

export default {
  data() {
    return {
      activeDayNo: 0,
      dialogProductType: '',
      showHotelMessage: false,
      showExcrMessage: false
    }
  },
  computed: {
    ...mapState({
      days: state => state.dayByDay.days
    }),
    ...mapGetters({
      hotels: 'getCountyHotels',
      excursions: 'getCountyExcursions',
      entertainments: 'getCountyEntertainments',
      getSelectedHotels: 'getSelectedHotels',
      getSelectedExcursions: 'getSelectedExcursions',
      getSelectedEntertainments: 'getSelectedEntertainments'
    }),
    products() {
      if (this.dialogProductType === 'Hotel') {
        return this.sortHotels(this.hotels)
      } else if (this.dialogProductType === 'Excursion') {
        return this.excursions
      }
      return this.entertainments
    },
    hasHotels() {
      return this.getSelectedHotels != null && this.getSelectedHotels.length > 0
    },
    hasExcursions() {
      return (
        (this.getSelectedExcursions != null &&
          this.getSelectedExcursions.length > 0) ||
        (this.getSelectedEntertainments != null &&
          this.getSelectedEntertainments.length > 0)
      )
    }
  },
  components: {
    appDbdDay,
    appProductDialog
  },
  methods: {
    ...mapActions(['setDialogProductType', 'prevStep']),
    showProductDialog(dayNo, productType) {
      this.activeDayNo = dayNo
      this.dialogProductType = productType
      this.$bvModal.show('product-dialog')
    },
    addProduct(productId, productTime) {
      // suppress any previous messages from displaying
      if (this.dialogProductType === 'Hotel') {
        this.showHotelMessage = false
      } else if (
        this.dialogProductType === 'Excursion' ||
        this.dialogProductType === 'Entertainment'
      ) {
        this.showExcrMessage = false
      }

      this.$store.dispatch('addProduct', {
        dayNo: this.activeDayNo,
        productId: productId,
        productTime: productTime
      })
      this.$bvModal.hide('product-dialog')
    },
    nextStep() {
      if (this.hasHotels && (this.hasExcursions || this.showExcrMessage)) {
        this.$store.dispatch('nextStep')
      } else if (this.hasHotels) {
        this.showExcrMessage = true
      } else {
        this.showHotelMessage = true
      }
    },
    sortHotels(hotels) {
      return hotels
        .sort(
          (a, b) =>
            parseInt(a.rating.substring(0, 1)) -
            parseInt(b.rating.substring(0, 1))
        )
        .reverse()
    }
  },
  created() {
    this.$store.dispatch('initDbdDays')
    eventBus.$on('selectProductClicked', this.showProductDialog)
    eventBus.$on('addProductClicked', this.addProduct)
  }
}
</script>
